/**
 * Created by Tiger on 21/02/2022.
 */

import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Button, Modal, Space, Table, Typography} from 'antd';
import i18n from 'i18next';
import {connect} from 'react-redux';
import actions from '../../redux/action';
import {SelectItem} from '../../components/select-item';
import {useTableSelection} from './use-table-selection';
import {http} from '../../common/request';
import {HttpURLS} from '../../common/http-url-define';
import {TablePagination} from '../../components/lib';
import styled from '@emotion/styled';

const ADD_DEVICES_STEP = {
  SELECT_DEVICE_TYPE: Symbol('选择设备类型'), SELECT_DEVICES: Symbol('选择设备'), SELECT_CONFIG: Symbol('选择配置'),
};

function NewDevice(props) {
  const [isAdding, setIsAdding] = useState(false);
  const { selectedMacs, rowSelection } = useTableSelection();
  const [modalWidth, setModalWidth] = useState(document.body.clientWidth / 4);
  const [step, setStep] = useState(ADD_DEVICES_STEP.SELECT_DEVICE_TYPE);
  const [productCode, setProductCode] = useState(null);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const nextButtonDisabled = useMemo(() => {
    return !((step === ADD_DEVICES_STEP.SELECT_DEVICE_TYPE && productCode) || (step === ADD_DEVICES_STEP.SELECT_DEVICES && selectedMacs.length > 0) || (step === ADD_DEVICES_STEP.SELECT_CONFIG && selectedConfig));
  }, [step, selectedMacs, productCode, selectedConfig]);
  const tableColumn = useMemo(() => {
    return [{ title: 'MAC/SN', dataIndex: 'mac', key: 'mac' }, {
      title: i18n.t('device_type'), dataIndex: 'name', key: 'name',
    }, {
      title: i18n.t('current_platform'), dataIndex: 'fromApp', key: 'current_platform',
    }, {
      title: i18n.t('create_time'), dataIndex: 'createAt', key: 'createAt',
      // sorter: (item1, item2) => item1.createAt > item2.createAt,
    }];
  }, [props.language]);
  const modelProps = useMemo(() => {
    let title, nextButtonText;
    switch (step) {
      case ADD_DEVICES_STEP.SELECT_DEVICE_TYPE:
        title = i18n.t('select_device_type');
        nextButtonText = i18n.t('next');
        break;
      case ADD_DEVICES_STEP.SELECT_DEVICES:
        title = i18n.t('select_devices');
        nextButtonText = i18n.t('next');
        break;
      case ADD_DEVICES_STEP.SELECT_CONFIG:
        title = i18n.t('select_config');
        nextButtonText = i18n.t('consent');
        break;
    }
    return { title, nextButtonText };
  }, [step]);
  useEffect(() => {
    props.onRefreshProducts(props.language);
  }, []);

  useEffect(() => {
    switch (step) {
      case ADD_DEVICES_STEP.SELECT_DEVICES:
        setModalWidth(document.body.clientWidth / 5 * 3);
        break;
      case ADD_DEVICES_STEP.SELECT_DEVICE_TYPE:
      case ADD_DEVICES_STEP.SELECT_CONFIG:
      default:
        setModalWidth(document.body.clientWidth / 4);

    }
  }, [step]);

  const next = useCallback(() => {
    if (step === ADD_DEVICES_STEP.SELECT_DEVICE_TYPE) {
      setStep(ADD_DEVICES_STEP.SELECT_DEVICES);
      props.onRefreshNotPrivateDevices(props.language, { hadPrivate: false, productCode, limit: 20, offset: 0 });
    } else if (step === ADD_DEVICES_STEP.SELECT_DEVICES) {
      setStep(ADD_DEVICES_STEP.SELECT_CONFIG);
      props.onRefreshConfigList();
    } else {
      setIsAdding(true);
      http('put', HttpURLS.DEVICE_URL, { macList: selectedMacs, privateConfigId: selectedConfig.value })
        .then(res => {
          const { code } = res.data;
          if (code === 200) {
            //延迟刷新，找服务端查看原因
            props.onRefreshPrivateDevices(props.language, { hadPrivate: true, limit: 20, offset: 0 });

            console.log('更新/新增设备成功：', code);
            props.onOk({ code, selectedRows: selectedMacs, selectedConfig });
          } else {
            props.onOk({ code });
            console.error('更新/新增设备失败：', code);
          }
        }).catch(err => {
        props.onOk({ code: err.toString() });
        console.error('更新/新增设备失败：', err);
      }).finally(() => {
        setIsAdding(false);
      });
    }

  }, [step, productCode, selectedConfig]);

  //1.选择设备类型
  const selectDeviceType = () => (<>
    <SelectItem defaultValue={ { value: productCode } } showArrow={ true } options={ props.products }
                placeholder={ i18n.t('select_device_type') } style={ { marginTop: 0 } }
                onChanged={ event => {
                  setProductCode(event?.value);
                } }
    />
  </>);

  //2.选择设备
  const refresh = params =>
    props.onRefreshNotPrivateDevices(props.language, { hadPrivate: false, productCode, ...params });
  const selectDevices = () => {
    return <>
      <label>{ i18n.t('select_devices2') }</label>
      <Table rowKey={ ({ mac }) => mac }
             scroll={ { x: 800, y: document.body.clientHeight / 2 } }
             style={ { marginTop: 20 } } rowSelection={ rowSelection }
             bordered={ true }
             columns={ tableColumn }
             dataSource={ props?.notPrivateDeviceList }
             pagination={ false }
             loading={ props.tableLoading }
             footer={ () => <PaginationContainer>
               <TablePagination
                 total={ props.total }
                 hideOnSinglePage={ props.total <= 20 }
                 pageSizeOptions={ [20, 40, 50, 100] }
                 currentPage={ props.currentPage }
                 pageSize={ props.pageSize }
                 refresh={ refresh }
               />
             </PaginationContainer> }
      />
    </>;
  };


  //3.选择配置
  const selectConfig = () => {
    console.log('selectConfig-callback:', selectedMacs);
    return <>
      <Typography.Text>
        { i18n.t('selected_devices_count').replace('@$', `${ selectedMacs.length }`) }
        <Button onClick={ () => setStep(ADD_DEVICES_STEP.SELECT_DEVICES) } style={ { paddingLeft: 5 } }
                type={ 'link' }>{ i18n.t('re_select') }</Button>
      </Typography.Text>
      <SelectItem showArrow={ true } placeholder={ i18n.t('select_config') } options={ props.configList }
                  style={ { marginTop: 20 } }
                  onChanged={ event => {
                    setSelectedConfig(event);
                  } }
      />
    </>;
  };
  return <Modal
    width={ modalWidth }
    onCancel={ props.onCancel }
    footer={ null }
    title={ modelProps.title }
    visible={ props.visible }
    style={ { maxHeight: document.body.clientHeight } }
  >
    { step === ADD_DEVICES_STEP.SELECT_DEVICE_TYPE && selectDeviceType() }
    { step === ADD_DEVICES_STEP.SELECT_DEVICES && selectDevices() }
    { step === ADD_DEVICES_STEP.SELECT_CONFIG && selectConfig() }
    <Space style={ { marginTop: 20, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' } }>
      { step === ADD_DEVICES_STEP.SELECT_DEVICES &&
      <Button onClick={ () => setStep(ADD_DEVICES_STEP.SELECT_DEVICE_TYPE) }>{ i18n.t('prev') }</Button> }
      <Button loading={ isAdding } disabled={ nextButtonDisabled } type={ 'primary' }
              onClick={ next }>{ modelProps.nextButtonText }</Button>
    </Space>
  </Modal>;
}

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
`;


const mapState2Props = state => {
  return {
    language: state.language.language,
    products: state.config.products,
    notPrivateDeviceList: [...state.device.notPrivateDeviceList],
    tableLoading: state.device.notPrivateDeviceListLoading,
    total: state.device.notPrivateDeviceListTotal,
    currentPage: state.device.notPrivateDeviceListCurrentPage,
    pageSize: state.device.notPrivateDeviceListPageSize,
    configList: state.config.configList.map(({ id, name }) => ({
      label: name, value: id,
    })),
  };
};

const mapDispatch2Props = dispatch => {
  return {
    onRefreshProducts: language => dispatch(actions.onRefreshProducts(language)),
    onRefreshNotPrivateDevices: (language, filter) => dispatch(actions.onRefreshNotPrivateDevices(language, filter)),
    onRefreshConfigList: () => dispatch(actions.onRefreshConfigList()),
    onRefreshPrivateDevices: (language, filter) => dispatch(actions.onDeviceList(language, filter)),
    onUpdateDevices: (language, devices) => dispatch(actions.onUpdateDevices(language, devices)),
  };
};

export default connect(mapState2Props, mapDispatch2Props)(NewDevice);
